import { sortBy } from "lodash";
import { useTranslation } from "next-i18next";
import React, { useEffect, useState } from "react";
import { IngredientListContent } from "@Types/recipes-detail-page";
import IngredientItem from "./IngredientItem";
import { NonWfIngredients } from "./NonWfIngredients";
import classes from "./RecipesDetail.module.scss";

interface IngredientListProps extends IngredientListContent {}

export const IngredientList = (props: IngredientListProps) => {
  const { t } = useTranslation("common");
  const [addToCartButtonTextForCA, setAddToCartButtonTextForCA] = useState("");
  const [addToCartButtonClassForCA, setAddToCartButtonClassForCA] = useState(
    classes["button"]
  );
  const {
    isCanadianUser,
    availability,
    isPickupAvailable,
    currentZipCodeAvialabilityStoreIdInStorageForCA,
    currentZipCodePickupAvailabilityForCA,
  } = props;

  useEffect(() => {
    if (!isCanadianUser) {
      setAddToCartButtonTextForCA(t("cart.buttons.add_to_cart"));
    } else if (
      isCanadianUser &&
      !availability &&
      !isPickupAvailable &&
      currentZipCodeAvialabilityStoreIdInStorageForCA === "false" &&
      currentZipCodePickupAvailabilityForCA === "false"
    ) {
      setAddToCartButtonTextForCA(t("cart.buttons.change_to_shop"));
      setAddToCartButtonClassForCA(classes["is_not_avilable--ca-only"]);
    } else {
      setAddToCartButtonTextForCA(t("cart.buttons.add_to_cart"));
      setAddToCartButtonClassForCA(classes["button"]);
    }
  }, [
    isCanadianUser,
    availability,
    isPickupAvailable,
    currentZipCodeAvialabilityStoreIdInStorageForCA,
    currentZipCodePickupAvailabilityForCA,
    t,
  ]);

  const ingredients = sortBy(props.ingredientsList?.items, ["isWfProduct"]).map(
    (ingredient, index) => {
      return (
        <IngredientItem
          key={index}
          {...ingredient}
          addToBasketText={
            !isCanadianUser
              ? props["cart.addToBasket"]
              : addToCartButtonTextForCA
          }
          addedText={
            !isCanadianUser ? props["cart.added"] : addToCartButtonTextForCA
          }
          removeInCartText={
            !isCanadianUser ? props["cart.removeInCart"] : props["cart.removed"]
          }
          removedText={props["cart.removed"]}
          isCanadianUser={isCanadianUser}
          addToCartButtonClassForCA={addToCartButtonClassForCA}
          availability={!!availability}
          isPickupAvailable={isPickupAvailable}
          currentZipCodeAvialabilityStoreIdInStorageForCA={
            currentZipCodeAvialabilityStoreIdInStorageForCA
          }
          currentZipCodePickupAvailabilityForCA={
            currentZipCodePickupAvailabilityForCA
          }
        />
      );
    }
  );

  return (
    <div className={classes["ingredient-list"]}>
      <h2>{props["recipe.page.ingredients"]}</h2>

      <ul>{ingredients}</ul>

      <NonWfIngredients {...props} />
    </div>
  );
};
